import styled from 'styled-components';
import { breakpoints, colors } from '@oxygen/theme';
import { ChevronRight } from '@styled-icons/material';

export const StyledPropertyTypeCounts = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  background-color: ${colors.storm10};
  h1 {
    text-align: center;
  }
`;

export const PropertyTypeCountList = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${breakpoints.medium}) {
    flex-direction: column;
  }
`;

export const StyledPropertyTypeCount = styled.a`
  &,
  &:link,
  &:active,
  &:visited {
    justify-content: space-between;
    color: ${colors.oldStorm};
    font-weight: 600;
    background-color: #fff;
    border: 1px solid ${colors.storm5};
    padding: 8px;
    border-radius: 4px;
    margin: 8px;
    cursor: pointer;
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    text-decoration: none;
  }
`;

export const CountWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 100%;
  text-align: center;
  background-color: ${hexToRgbA(colors.overcast, 0.2)};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
`;

export const Count = styled.span`
  font-size: 18px;
  color: ${colors.overcast};
`;

export const Plus = styled.span`
    ::after {
    content: '+';
    font-size: 14px;
`;

export const PropertyTypeCountContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  text-align: center;
  overflow: hidden;
`;

export const CountDescription = styled.div`
  font-size: 13px;
  margin: auto;
  align-items: center;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  text-align: left;
  line-height: 25px;
`;

export const Heading = styled.h1`
  font-style: normal;
  font-weight: 600;
  padding: 16px;
  color: ${colors.oldStorm};
`;

export const Chevron = styled(ChevronRight)`
  width: 2.5rem;
  cursor: pointer;
  color: ${colors.oldStorm};
`;

function hexToRgbA(hex, opacity) {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return `rgba( ${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')} ,${
      opacity || 1
    })`;
  }
  throw new Error('Bad Hex');
}
